import * as React from 'react';
import { Row, Form, Col } from 'react-bootstrap';
import * as _ from 'lodash'
import config from '../../constants/config';

import { copyObject } from '../../utils';
import { dir } from 'console';
import GoogleMapAutoComplete from '../../components/MapBoxAutoComplete/GoogleMapAutoComplete';

export interface IAddressesProps {
    addressFrom: string
    addressTo: string
    noAddressTo: boolean
    onChangeInputs(key: string, value: any): void
}

const Addresses: React.FC<IAddressesProps> = ({ addressFrom, addressTo, noAddressTo, onChangeInputs }) => {
    const [dirty, setDirty] = React.useState({
        addressFrom: "",
        addressTo: "",
    });

    const onPressAddress = (key: string, location) => {
        onChangeInputs(key, location.verbose_address)
    }

    const updateDirty = (key: string, value: any): void => {
        let cloneDirty = copyObject(dirty)
        cloneDirty[key] = value
        setDirty(cloneDirty)
    }
    return (
        <div className="mb-2">
            <Row >
                <Form.Group as={Col} md="6 mb-3" controlId="addressFrom">
                    <h3>Moving From</h3>
                    <GoogleMapAutoComplete
                        idAddresss="address_From"
                        className='input-material'
                        apiKey={config.keyMap}
                        onChangeText={text => {

                            updateDirty("addressFrom", text)
                            onChangeInputs("addressFrom", "")
                        }}
                        onPress={async (location) => {
                            onChangeInputs("addressFrom", location.verbose_address)
                            updateDirty("addressFrom", location.verbose_address)
                        }}

                        placeholder=''
                        textValue={`${dirty.addressFrom}`}
                    />

                </Form.Group>

                <Form.Group as={Col} md="6 mb-3" controlId="addressTo">
                    <h3>Moving To</h3>
                    <GoogleMapAutoComplete
                        apiKey={config.keyMap}
                        idAddresss="address_to"
                        className='input-material'

                        onChangeText={text => {
                            updateDirty("addressTo", text)
                            onChangeInputs("addressTo", "")
                        }}
                        onPress={async location => {
                            onChangeInputs("addressTo", location.verbose_address)
                            updateDirty("addressTo", location.verbose_address)
                        }}
                        placeholder=''
                        textValue={`${dirty.addressTo}`}
                    />

                    <Form.Check
                        id={`custom-noAddressTo`}
                        type="checkbox" onChange={(event) => {
                            onChangeInputs("noAddressTo", !noAddressTo)
                        }}
                        // custom 
                        label="No Second Location" />
                </Form.Group>

            </Row >
        </div>
    );
}

export { Addresses };